import {RequestService} from '../RequestService/RequestService';
import {insertThrobber, removeThrobber} from '../Utility/GlobalFunctions';

export class RegisterController {
  private registerForm;

  constructor() {
    if (document.getElementsByClassName('tx-slnr-downloads') || document.getElementsByClassName('product-page')) {
      this.registerForm = document.querySelector('.js-RegisterForm');
      this.init();
    }
  }

  init() {
    if (this.registerForm) {
      this.registerForm.addEventListener('submit', e => {
        e.preventDefault();
        this.register();
        insertThrobber(this.registerForm);
      });
    }
  }
  private async register() {
    const options = {
      method: this.registerForm.method,
      body: new FormData(this.registerForm),
    };
    const data = await new RequestService().getRequestJson(this.registerForm.action, options);
    removeThrobber();
    if (data.noEmployee) {
      const noEmployeeError = this.registerForm.querySelector('.js-error-no-employee');
      if (noEmployeeError) {
        noEmployeeError.innerHTML = '';
        noEmployeeError.insertAdjacentHTML('beforeend', data.noEmployee);
        noEmployeeError.classList.remove('hidden');
      }
    } else if (data.existingEmail) {
      const emailError = this.registerForm.querySelector('.js-error-email-already-exist');
      if (emailError) {
        emailError.innerHTML = '';
        emailError.insertAdjacentHTML('beforeend', data.existingEmail);
        emailError.classList.remove('hidden');
      }
    } else if (data.errorMessage) {
      const emailNotSent = this.registerForm.querySelector('.js-error-email-not-sent');
      if (emailNotSent) {
        emailNotSent.innerHTML = '';
        emailNotSent.insertAdjacentHTML('beforeend', data.errorMessage);
      }
    } else if (data.captcha) {
      const captchaFailed = this.registerForm.querySelector('.js-error-captcha');
      if (captchaFailed) {
        captchaFailed.insertAdjacentHTML('beforeend', data.captcha);
        captchaFailed.classList.remove('hidden');
      }
    } else {
      window.location.href = data.redirectSuccessUrl;
    }
  }
}
